import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=1acfb8fa&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"
import style0 from "./admin.vue?vue&type=style&index=0&id=1acfb8fa&prod&lang=less&scoped=true"
import style1 from "./admin.vue?vue&type=style&index=1&id=1acfb8fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acfb8fa",
  null
  
)

export default component.exports